import React from 'react';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { getMomentDate } from '../../../../Utils/dates.util';
import useFilters from '../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';

export interface MonitoringCenterSolvedRequestsFilterValues {
	caseTypeIds?: string[];
	priorityId?: string;
	patientId?: string;
	date?: string;
	caseStatusValue?: string;
	doctorId?: string;
	attendingDoctorId?: string;
	workplaceId?: string;
	createdAt?: string;
	code?: string;
	caseTypeCode?: string;
	solved: boolean;
	solvedAtRange?: {
		from: string;
		to: string;
	};
}

interface Props {
	onFilter: (values: MonitoringCenterSolvedRequestsFilterValues) => void;
}

const MonitoringCenterSolvedRequestsFilter: React.FC<Props> = ({
	onFilter,
}) => {
	const {
		handleSelectValue,
		handleDateRange,
		handleDateRangeVisibility,
		handleDateRangeInPicker,
		isDateRangeVisible,
	} = useFilters();
	const onFilterData = (values: any) => {
		handleDateRangeVisibility(values?.createdAt?.value);
		const filter: MonitoringCenterSolvedRequestsFilterValues = {
			caseTypeIds: values?.caseTypeIds?.length
				? values.caseTypeIds.map((item: SelectValue) => item.value)
				: undefined,
			priorityId: values?.priorityId?.value || undefined,
			patientId: values?.patient?.value || undefined,
			createdAt: handleDateRangeInPicker(values?.createdAt?.value),
			caseStatusValue: values?.caseStatus?.value,
			attendingDoctorId: handleSelectValue(values?.attendingDoctor?.value),
			doctorId: handleSelectValue(values?.assignedDoctor?.value),
			workplaceId: handleSelectValue(values?.workplaceId?.value),
			code: values?.code || undefined,
			caseTypeCode: values?.caseTypeCode?.value,
			solvedAtRange: handleDateRange(values?.dateFrom, values?.dateTo),
			solved: true,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.MONITROING_CENTER_SOLVED_REQUESTS_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.ROOT_CASE_TYPE_CODE}
				width={340}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_PRIORITY}
				width={280}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ORIGINAL_ID_FROM_ALL_WORKPLACES}
				width={330}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				customLabel='Stav'
				type={GridFilterItemType.CASE_STATUS}
				width={190}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_CREATE_DAY}
				width={220}
				customPlaceholder='base.shared.pick'
				enableAutocomplete
				customLabel='component.monitoringCenter.filter.created'
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={170}
				customLabel='base.shared.from'
				enableAutocomplete
				visible={isDateRangeVisible}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={170}
				customLabel='base.shared.to'
				enableAutocomplete
				visible={isDateRangeVisible}
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_CODE}
				width={220}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={330}
				customLabel='base.shared.attendingDoctor'
				customPlaceholder='base.startTypingSurname'
				customKey='attendingDoctor'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.MEDIC_ID_FROM_ALL_WORKPLACES}
				width={330}
				customLabel='component.monitoringCenter.tableHead.closedBy'
				customPlaceholder='base.startTypingSurname'
				customKey='assignedDoctor'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACE}
				width={330}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default MonitoringCenterSolvedRequestsFilter;
